( function () {
	'use strict';

	var initializedSplides = new WeakSet();

	function initTestimonialsSlider( section ) {
		const splideEl = section.querySelector( '.testimonials-slider__splide' );
		const prevBtn  = section.querySelector( '.testimonials-slider__arrow--prev' );
		const nextBtn  = section.querySelector( '.testimonials-slider__arrow--next' );

		if ( ! splideEl || typeof window.Splide === 'undefined' ) return;
		if ( initializedSplides.has( splideEl ) ) return;
		initializedSplides.add( splideEl );

		const splide = new window.Splide( splideEl, {
			type:       'fade',
			rewind:     true,
			arrows:     false,
			pagination: true,
			drag:       true,
		} );

		if ( prevBtn ) prevBtn.addEventListener( 'click', () => splide.go( '<' ) );
		if ( nextBtn ) nextBtn.addEventListener( 'click', () => splide.go( '>' ) );

		splide.mount();
	}

	function boot() {
		document.querySelectorAll( '.testimonials-slider' ).forEach( initTestimonialsSlider );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', boot );
	} else {
		boot();
	}

	if ( typeof wp !== 'undefined' && wp.domReady ) {
		wp.domReady( function () {
			boot();

			const observer = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					mutation.addedNodes.forEach( function ( node ) {
						if ( ! ( node instanceof HTMLElement ) ) return;
						if ( node.closest( '.splide__pagination' ) ) return;
						if ( node.closest( '.splide__arrows' ) ) return;

						const sections = node.classList.contains( 'testimonials-slider' )
							? [ node ]
							: Array.from( node.querySelectorAll( '.testimonials-slider' ) );

						sections.forEach( initTestimonialsSlider );
					} );
				} );
			} );

			observer.observe( document.body, { childList: true, subtree: true } );
		} );
	}

}() );